module.exports = __webpack_public_path__ + "pcstatic/img/head-bg.46565f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/header/head-bg.jpg
// module id = MN1W
// module chunks = 30